import auth from '../../auth';
import router from '../../../router';

export default (error) => {
  if (error.response.status !== 401) {
    return Promise.reject(error);
  }

  auth.token.destroy();
  router.push({ path: '/login' });

  return Promise.reject({});
};



// WEBPACK FOOTER //
// ./src/helpers/request/interceptors/token.js